module.exports = __webpack_public_path__ + "greenlotus.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/greenlotus.png
// module id = 298
// module chunks = 0